/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Contactbody1Inputs */

const id_about_contactbody1 = /** @type {(inputs: About_Contactbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda dapat menghubungi kami melalui`)
};

const ms_about_contactbody1 = /** @type {(inputs: About_Contactbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anda boleh menghubungi kami melalui`)
};

const da_about_contactbody1 = /** @type {(inputs: About_Contactbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du kan kontakte os via`)
};

const de_about_contactbody1 = /** @type {(inputs: About_Contactbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sie können uns kontaktieren über`)
};

const en_us2_about_contactbody1 = /** @type {(inputs: About_Contactbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can contact us via`)
};

const es_es2_about_contactbody1 = /** @type {(inputs: About_Contactbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puedes contactarnos vía`)
};

const es_mx2_about_contactbody1 = /** @type {(inputs: About_Contactbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puedes contactarnos por`)
};

const fil_about_contactbody1 = /** @type {(inputs: About_Contactbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maaari kang makipag-ugnayan sa amin sa pamamagitan ng`)
};

const fr_about_contactbody1 = /** @type {(inputs: About_Contactbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous pouvez nous contacter via`)
};

const it_about_contactbody1 = /** @type {(inputs: About_Contactbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puoi contattarci tramite`)
};

const hu_about_contactbody1 = /** @type {(inputs: About_Contactbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapcsolatba léphetsz velünk a következőn keresztül`)
};

const nl_about_contactbody1 = /** @type {(inputs: About_Contactbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je kunt ons bereiken via`)
};

const no_about_contactbody1 = /** @type {(inputs: About_Contactbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du kan kontakte oss via`)
};

const pl_about_contactbody1 = /** @type {(inputs: About_Contactbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Możesz się z nami skontaktować przez`)
};

const pt_br2_about_contactbody1 = /** @type {(inputs: About_Contactbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você pode entrar em contato conosco através`)
};

const pt_about_contactbody1 = /** @type {(inputs: About_Contactbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pode contactar-nos através de`)
};

const ro_about_contactbody1 = /** @type {(inputs: About_Contactbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ne puteți contacta prin`)
};

const fi_about_contactbody1 = /** @type {(inputs: About_Contactbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voit ottaa meihin yhteyttä`)
};

const sv_about_contactbody1 = /** @type {(inputs: About_Contactbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du kan kontakta oss via`)
};

const vi_about_contactbody1 = /** @type {(inputs: About_Contactbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bạn có thể liên hệ với chúng tôi qua`)
};

const tr_about_contactbody1 = /** @type {(inputs: About_Contactbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bizimle şu yolla iletişime geçebilirsiniz`)
};

const cs_about_contactbody1 = /** @type {(inputs: About_Contactbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Můžete nás kontaktovat prostřednictvím`)
};

const bg_about_contactbody1 = /** @type {(inputs: About_Contactbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Можете да се свържете с нас чрез`)
};

const ru_about_contactbody1 = /** @type {(inputs: About_Contactbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы можете связаться с нами через`)
};

const uk_about_contactbody1 = /** @type {(inputs: About_Contactbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ви можете зв'язатися з нами через`)
};

const ar_about_contactbody1 = /** @type {(inputs: About_Contactbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يمكنك الاتصال بنا عبر`)
};

const hi_about_contactbody1 = /** @type {(inputs: About_Contactbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आप हमसे संपर्क कर सकते हैं`)
};

const th_about_contactbody1 = /** @type {(inputs: About_Contactbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณสามารถติดต่อเราผ่าน`)
};

const ja_about_contactbody1 = /** @type {(inputs: About_Contactbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`こちらからお問い合わせいただけます：`)
};

const zh_cn2_about_contactbody1 = /** @type {(inputs: About_Contactbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您可以通过以下方式联系我们`)
};

const zh_hant1_about_contactbody1 = /** @type {(inputs: About_Contactbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`您可以透過以下方式聯絡我們`)
};

const ko_about_contactbody1 = /** @type {(inputs: About_Contactbody1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`다음을 통해 문의할 수 있습니다`)
};

/**
* | output |
* | --- |
* | "You can contact us via" |
*
* @param {About_Contactbody1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const about_contactbody1 = /** @type {((inputs?: About_Contactbody1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Contactbody1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_about_contactbody1(inputs)
	if (locale === "ms") return ms_about_contactbody1(inputs)
	if (locale === "da") return da_about_contactbody1(inputs)
	if (locale === "de") return de_about_contactbody1(inputs)
	if (locale === "en-US") return en_us2_about_contactbody1(inputs)
	if (locale === "es-ES") return es_es2_about_contactbody1(inputs)
	if (locale === "es-MX") return es_mx2_about_contactbody1(inputs)
	if (locale === "fil") return fil_about_contactbody1(inputs)
	if (locale === "fr") return fr_about_contactbody1(inputs)
	if (locale === "it") return it_about_contactbody1(inputs)
	if (locale === "hu") return hu_about_contactbody1(inputs)
	if (locale === "nl") return nl_about_contactbody1(inputs)
	if (locale === "no") return no_about_contactbody1(inputs)
	if (locale === "pl") return pl_about_contactbody1(inputs)
	if (locale === "pt-BR") return pt_br2_about_contactbody1(inputs)
	if (locale === "pt") return pt_about_contactbody1(inputs)
	if (locale === "ro") return ro_about_contactbody1(inputs)
	if (locale === "fi") return fi_about_contactbody1(inputs)
	if (locale === "sv") return sv_about_contactbody1(inputs)
	if (locale === "vi") return vi_about_contactbody1(inputs)
	if (locale === "tr") return tr_about_contactbody1(inputs)
	if (locale === "cs") return cs_about_contactbody1(inputs)
	if (locale === "bg") return bg_about_contactbody1(inputs)
	if (locale === "ru") return ru_about_contactbody1(inputs)
	if (locale === "uk") return uk_about_contactbody1(inputs)
	if (locale === "ar") return ar_about_contactbody1(inputs)
	if (locale === "hi") return hi_about_contactbody1(inputs)
	if (locale === "th") return th_about_contactbody1(inputs)
	if (locale === "ja") return ja_about_contactbody1(inputs)
	if (locale === "zh-CN") return zh_cn2_about_contactbody1(inputs)
	if (locale === "zh-Hant") return zh_hant1_about_contactbody1(inputs)
	return ko_about_contactbody1(inputs)
});
export { about_contactbody1 as "about.contactBody" }